var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRadioSmall = function SvgRadioSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.816 7.996c0-1.245.717-2.324 1.76-2.846l-.569-1.138a4.455 4.455 0 0 0 0 7.971l.57-1.139a3.182 3.182 0 0 1-1.76-2.848m6.364 0a3.182 3.182 0 0 0-1.757-2.845l.57-1.138a4.455 4.455 0 0 1 0 7.97l-.57-1.14a3.182 3.182 0 0 0 1.757-2.847m2.546.005a5.727 5.727 0 0 0-3.166-5.124l.57-1.14A7 7 0 0 1 15 8a7 7 0 0 1-3.868 6.262l-.57-1.138A5.727 5.727 0 0 0 13.727 8M1 8a7 7 0 0 1 3.87-6.264l.569 1.14a5.727 5.727 0 0 0-.002 10.249l-.569 1.136A7 7 0 0 1 1 8m6.999 1.907a1.91 1.91 0 1 0 0-3.818 1.91 1.91 0 0 0 0 3.818",
    clipRule: "evenodd"
  })));
};
export default SvgRadioSmall;